import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {navigationHeight} from "@pg-rp/navigation";

import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const HomepageHeader = () => {
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();

    const blendHeight = `${(headerBoundingClientRect?.height || 0) + navigationHeight}px`;
    const blendTopPosition = headerBoundingClientRect ? `${Math.max(Math.floor(headerBoundingClientRect.height - navigationHeight), 0)}px` : "0px";

    return (
        <section className={homepageHeader}>
            <div className={homepageHeaderFrame} ref={headerElementRef}>
                <div className={homepageHeaderImageClip}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: headerXs, height: 488, width: 360},
                            {minWidthPX: 360, src: headerSm, height: 488, width: 600},
                            {minWidthPX: 600, src: headerMd, height: 512, width: 1366},
                            {minWidthPX: 1366, src: headerLg, height: 712, width: 1920},
                            {minWidthPX: 1919, src: headerXl, height: 984, width: 2560}
                        ]}
                        alt="header"
                        className={headerImageCss}
                        fit="center center"
                        fetchPriority="high"
                    />
                    <div className={homepageHeaderImageOverlay} />
                </div>

                <div className={homepageHeaderContentPositioner}>
                    <div className={homepageHeaderContentGroup}>
                        <HomepageHeaderContent />
                        <HomepageSearch
                            containerHeight={blendHeight}
                            blendTopPosition={blendTopPosition}
                            layoutVariant="hero"
                            submitMode="manual"
                            mobileSelectionMode="selectAndClose"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export const homepageHeader = css({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    px: 0,

    sm: {
        px: 3,
        pt: 2
    },

    lg: {
        px: 4
    }
});

export const homepageHeaderFrame = css({
    position: "relative",
    width: "100%",
    maxWidth: "1280px",
    height: "420px",
    overflow: "visible",

    sm: {
        height: "360px"
    },

    md: {
        height: "540px"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)",
        height: "540px"
    },

    xl: {
        height: "540px"
    }
});

export const homepageHeaderImageClip = css({
    position: "absolute",
    inset: 0,
    overflow: "hidden",

    sm: {
        borderRadius: 2
    }
});

export const homepageHeaderImageOverlay = css({
    position: "absolute",
    inset: 0,
    zIndex: 1,
    pointerEvents: "none",
    backgroundColor: "#23232D80"
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    boxSizing: "border-box",
    width: "100%",
    px: 2,
    pt: 3,
    pb: 3,
    zIndex: 10,

    md: {
        alignItems: "center",
        px: 4,
        pt: 0,
        pb: 0
    }
});

export const homepageHeaderContentGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    gap: 0,

    md: {
        justifyContent: "center",
        height: "auto",
        gap: "6.4rem"
    }
});

export const headerImageCss = css({
    width: "100%",
    height: "100%",

    "& img": {
        width: "100%",
        height: "100%",
        maxWidth: "none",
        objectFit: "cover"
    }
});
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {navigationHeight} from "@pg-rp/navigation";

import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const HomepageHeader = () => {
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();

    const blendHeight = `${(headerBoundingClientRect?.height || 0) + navigationHeight}px`;
    const blendTopPosition = headerBoundingClientRect ? `${Math.max(Math.floor(headerBoundingClientRect.height - navigationHeight), 0)}px` : "0px";

    return (
        <section className={homepageHeader}>
            <div className={homepageHeaderFrame} ref={headerElementRef}>
                <div className={homepageHeaderImageClip}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: headerXs, height: 488, width: 360},
                            {minWidthPX: 360, src: headerSm, height: 488, width: 600},
                            {minWidthPX: 600, src: headerMd, height: 512, width: 1366},
                            {minWidthPX: 1366, src: headerLg, height: 712, width: 1920},
                            {minWidthPX: 1919, src: headerXl, height: 984, width: 2560}
                        ]}
                        alt="header"
                        className={headerImageCss}
                        fit="center center"
                        fetchPriority="high"
                    />
                    <div className={homepageHeaderImageOverlay} />
                </div>

                <div className={homepageHeaderContentPositioner}>
                    <div className={homepageHeaderContentGroup}>
                        <HomepageHeaderContent />
                        <HomepageSearch
                            containerHeight={blendHeight}
                            blendTopPosition={blendTopPosition}
                            layoutVariant="hero"
                            submitMode="manual"
                            mobileSelectionMode="selectAndClose"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export const homepageHeader = css({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    px: 0,

    sm: {
        px: 3,
        pt: 2
    },

    lg: {
        px: 4
    }
});

export const homepageHeaderFrame = css({
    position: "relative",
    width: "100%",
    maxWidth: "1280px",
    height: "420px",
    overflow: "visible",

    sm: {
        height: "360px"
    },

    md: {
        height: "540px"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)",
        height: "540px"
    },

    xl: {
        height: "540px"
    }
});

export const homepageHeaderImageClip = css({
    position: "absolute",
    inset: 0,
    overflow: "hidden",

    sm: {
        borderRadius: 2
    }
});

export const homepageHeaderImageOverlay = css({
    position: "absolute",
    inset: 0,
    zIndex: 1,
    pointerEvents: "none",
    backgroundColor: "#23232D80"
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    boxSizing: "border-box",
    width: "100%",
    px: 2,
    pt: 3,
    pb: 3,
    zIndex: 10,

    md: {
        alignItems: "center",
        px: 4,
        pt: 0,
        pb: 0
    }
});

export const homepageHeaderContentGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    gap: 0,

    md: {
        justifyContent: "center",
        height: "auto",
        gap: "6.4rem"
    }
});

export const headerImageCss = css({
    width: "100%",
    height: "100%",

    "& img": {
        width: "100%",
        height: "100%",
        maxWidth: "none",
        objectFit: "cover"
    }
});
